import {
  CurrencyValue,
  LineChart,
  formatNumber,
  formatCurrency
} from '@blockanalitica/ui';
import type {
  SimpleChartData,
  SimpleChartDataset
} from '@blockanalitica/ui/package/types/src/components/charts/SimpleChart';
import { ReactNode, useCallback, useMemo } from 'react';
import { useChartPeriod } from '@/hooks';
import { tokensMapping } from '@/utils/tokens';

export default function HistoricGraphs({
  data,
  type,
  timeFilter,
  chartDaysAgo
}: {
  data: SimpleChartData[];
  type: string;
  timeFilter: ReactNode;
  chartDaysAgo: string | number;
}) {
  const [, updateChartConfigWithPeriod] = useChartPeriod(chartDaysAgo);
  const config = updateChartConfigWithPeriod();
  const datasets = useMemo(() => {
    const datasets: SimpleChartDataset[] = [
      {
        xField: 'date',
        yField: type
      }
    ];

    return datasets;
  }, [type]);

  const valueFormatter = useCallback(
    (value: number) => {
      switch (type) {
        case 'revenue':
          return (
            <CurrencyValue
              value={value}
              options={{
                currency: 'USD'
              }}
            />
          );
        case 'reserve':
          return (
            <CurrencyValue
              value={value}
              options={{
                currency: 'USDC'
              }}
            />
          );
        default:
          return (
            <CurrencyValue
              value={value}
              options={{
                currency: tokensMapping('DAI'),
                iconSize: '3'
              }}
            />
          );
      }
    },
    [type]
  );

  const yScaleValueFormatter = useCallback(
    (value: number) => {
      switch (type) {
        case 'revenue':
          return formatCurrency(value);

        default:
          return formatNumber(value);
      }
    },
    [type]
  );
  return (
    <LineChart
      key={type}
      data={data}
      datasets={datasets}
      valueFormatter={valueFormatter}
      yScaleValueFormatter={yScaleValueFormatter}
      timeFilter={timeFilter}
      config={config}
    />
  );
}
